export const PROFILE_SCREEN = {
  SIGN_MODAL: 'sign-modal',
  FORGOT_PASSWORD_MODAL: 'forgot-password-modal',
};
